module.exports = "/assets/data/7ea912f702149be30f7c7b47b80f1991-WF8.data.json";